/**
 * Created by zack on 2016/7/25.
 */
import http from './config'

export default {
  getIp () {
    return http.getIp()
  },
  fetch_weixin_auth () {
    return http.WeixinPost('wechatauth/get_wechatauth', {url: window.location.href.split('#')[0]})
  },
  login ({phoneNo, authCode}) {
    return http.ExpertPost('quick_login', {phone_no: phoneNo, auth_code: authCode})
  },
  send_sms (phone) {
    return http.ExpertPost('send_sms', {phone_no: phone})
  },
  fetchHtml (url) {
    return http.getHtml(url)
  },
  fetch_college_info (cID) {
    return http.get('colleges/' + cID)
  },
  fetch_instance_info ({collegeId, instanceId}) {
    return http.get('colleges/' + collegeId + '/instances/' + instanceId)
  },
  fetch_resource ({collegeId, sourceId, limit, offset}) {
    return http.get('colleges/' + collegeId + '/resources/' + sourceId + '?limit=' + limit + '&offset=' + offset)
  },
  fetch_resource_detail ({collegeID, resID, detID}) {
    return http.get('colleges/' + collegeID + '/resources/' + resID + '/details/' + detID)
  },
  fetch_expert_list ({collegeId, limit, offset}) {
    return http.get('colleges/' + collegeId + '/experts' + '?limit=' + limit + '&offset=' + offset)
  },
  //  新接口
  // fetch_expert_list (uID, limit, offset) {
  //   return http.get('universities/' + uID + '/experts' + '?limit=' + limit + '&offset=' + offset)
  // },
  fetch_expert_info ({collegeID, expertID}) {
    return http.ExpertPost('get_expert_info_by_user', {college_id: collegeID, expert_id: expertID})
  },
  fetch_expert_question (cID, expertID, type, offset, limit) {
    return http.ExpertPost('read_expert_questions_list_by_user', {college_id: cID, expert_id: expertID, type: type, offset: offset, limit: limit})
  },
  fetch_user_question (userId, offset, limit) {
    return http.ExpertPost('read_user_questions_list', {userId: userId, offset: offset, limit: limit})
  },
  submit_question (cID, expertID, question) {
    return http.ExpertPost('insert_expert_question', {college_id: cID, expert_id: expertID, question: question})
  },
  fetch_enrollPlan (cID, offset, limit) {
    return http.get('colleges/' + cID + '/plan' + '?limit=' + limit + '&offset=' + offset)
  },
  fetch_enrollResult (cID, offset, limit) {
    return http.get('colleges/' + cID + '/enroll' + '?limit=' + limit + '&offset=' + offset)
  },
  // test 招生计划
  fetch_enrollPlan_tab ({collegeId, data}) {
    return http.post('colleges/' + collegeId + '/filterPlan', {data: data})
  },
  // test 招生计划
  fetch_enrollPlan_data ({collegeId, limit, offset, data}) {
    return http.post('colleges/' + collegeId + '/filterPlanNow?limit=' + limit + '&offset=' + offset, {data: data})
  },
  // test 历年录取
  fetch_enrollResult_tab ({collegeId, data}) {
    return http.post('colleges/' + collegeId + '/filterenroll', {data})
  },
  // test 历年录取
  fetch_enrollResult_data ({collegeId, limit, offset, data}) {
    return http.post('colleges/' + collegeId + '/filterenrollNow?limit=' + limit + '&offset=' + offset, {data})
  },
  fetch_common_problem (cID, limit, offset) {
    return http.get('colleges/' + cID + '/model_qa/' + '?limit=' + limit + '&offset=' + offset)
  },
  fetch_major ({collegeId, majorId}) {
    return http.getMSJson('colleges/' + collegeId + '/majors/' + majorId + '.json')
  },
  // 访问次数统计
  logger (data) {
    return http.postCourse('modules/logger', data)
  },
  // 微信get
  get_weixin (phone) {
    return http.WeixinGet('wechatevent/get_app_qr_ticket?teacher_corp_id=' + phone)
  },
  getHtml (url) {
    return http.getHtml(url)
  },
  // 获取小程序码
  getMiniProgram (school) {
    return http.getMiniProgram('consult/wxQrcodeManage/getBySchool/?school=' + school)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js